






















































import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import {
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faPen,
  faTrash
} from '@fortawesome/free-solid-svg-icons'
import { mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { User } from '~/models/user/types'
import CUserAccessTogglesButton from '~/components/shared/configurable/access-toggle/CUserAccessTogglesButton.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { CUserAccessTogglesButton },
  props: {
    visibility: { type: Boolean, default: true },
    user: { type: Object as PropType<User>, required: true },
    reportVisible: { type: Boolean, default: false },
    editVisible: { type: Boolean, default: false },
    deleteVisible: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapState(USER_NS, {
      currentUserId: state => state.id
    }),
    isOwner(): boolean {
      return this.currentUserId === this.user?.id
    },
    visibilityIcon(): IconDefinition {
      return this.visibility ? this.icons.visible : this.icons.invisible
    },
    visibilityTitle(): IconDefinition {
      return this.visibility ? this.$i18n.t('show') : this.$i18n.t('hide')
    },
    icons() {
      return {
        report: faExclamationTriangle,
        edit: faPen,
        delete: faTrash,
        visible: faEye,
        invisible: faEyeSlash
      }
    }
  }
})
